<template>
  <main-layout :selectedMenu="'home'">
    <div class="container">
      <asideCom :activityIndex="9"></asideCom>
      <div class="my-content">
        <div class="top-choose">
          <div class="message choose">{{$t('global.我的订阅')}}</div>
        </div>
        <div class="subscribe-wrap">
          <filter-table v-model="selectedFilters"
                        v-bind:cate="filterList"></filter-table>
        </div>

        <pages></pages>
      </div>
    </div>
    <service></service>
  </main-layout>

</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout"
import service from '@/components/service.vue'
import asideCom from '@/components/aside.vue'
import pages from '@/components/pages.vue'
import FilterTable from '@/components/FilterTable.vue'

export default {
  name: 'manageVideo',
  metaInfo() {
    return {
      title: this.$t("global.我的订阅") + " | MANA"
    };
  },
  data() {
    return {
      contentIndex: 0,
      selectedFilters: [],
      filterList: []
    }
  },
  components: {
    MainLayout,
    service,
    asideCom,
    pages,
    FilterTable
  },
  created() {
    var $this = this
    $this.filterList = [
      {
        name: this.$t('global.行 业'),
        list: []
      },
      {
        name: this.$t('global.专 业'),
        list: []
      },
      {
        name: this.$t('global.热 门'),
        list: []
      }
    ]
    this.$http.get('/api/common/categoryList').then(function(response) {
      if (response.data.industryList) {
        for (var i = 0; i < response.data.industryList.length; i++) {
          $this.filterList[0].list.push({
            name: response.data.industryList[i]['title'],
            value: response.data.industryList[i]['categoryId'],
            cat: 1
          })
        }
      }
      if (response.data.professionList) {
        for (var i = 0; i < response.data.professionList.length; i++) {
          $this.filterList[1].list.push({
            name: response.data.professionList[i]['title'],
            value: response.data.professionList[i]['categoryId'],
            cat: 2
          })
        }
      }
    })
    this.$http.get('/api/video/hotTags').then(function(response) {
      if (response.data) {
        for (var i = 0; i < response.data.length; i++) {
          $this.filterList[2].list.push({
            name: response.data[i].title,
            value: response.data[i].id,
            cat: 3
          })
        }
      }
    })
    this.$http.get('/api/video/subscriptionCategory').then(function(response) {
      if (response.data) {
        for (var i = 0; i < response.data.length; i++) {
          $this.selectedFilters.push(response.data[i])
        }
      }
    })
  },
  methods: {
    changeIndex(index) {
      this.contentIndex = index
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.my-content
  width 10.8rem
  background-color #ffffff
  padding 0.5rem 0.6rem
  .top-choose
    display flex
    justify-content center
    font-size 0.26rem
    color #707070
    span
      display block
      margin 0 0.65rem
    .choose
      color #333333
      font-weight bold
.container
  margin 0.8rem auto
  display flex
</style>



// WEBPACK FOOTER //
// src/pages/my/account/Subscribe.vue